














































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../lib/util";
import AbpBase from "../../lib/abpbase";
import Region from "../../store/entities/booking/region";
import Ajax from "../../lib/ajax";
import SinglePicture from "../../components/single-picture.vue";
@Component({
    components: {SinglePicture}
})
export default class CreateRegion extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop({type:[Number,null],default:null}) parentId: number;
    region: Region = new Region();
    async save() {
        this.region.parentId = this.parentId;
        (this.$refs.regionForm as any).validate(async (valid: boolean) => {
            if (valid) {
                await Ajax.post('/api/services/app/Region/Create',this.region);
                (this.$refs.regionForm as any).resetFields();

                this.$emit("save-success");
                this.$emit("input", false);
            }
        });
    }
    cancel() {
        (this.$refs.regionForm as any).resetFields();
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        }
    }
    regionRule = {
        name: [
            {
                required: true,
                message: this.L("FieldIsRequired", undefined, this.L("RegionName")),
                trigger: "blur"
            },
            {
                type: 'string',
                max: 256,
                message: this.L("NoMoreThenLength",undefined,this.L("RegionName"),"256"),
                trigger: "blur"
            }
        ],
        //  displayOrder: [{
        //     required: true,
        //     message: '请输入显示排序',
        //     trigger: "blur",
        //     type: "number"
        // }],
    };
}
